import { render } from "./DhTable.vue?vue&type=template&id=654b2a55"
import script from "./DhTable.vue?vue&type=script&lang=ts"
export * from "./DhTable.vue?vue&type=script&lang=ts"
script.render = render

export default script